import React from "react";

// The person on our side, by name and face, wherever a client might wonder
// who to ask. The same picture and words as the About page.
export const HOST = {
  name: "Mariusz Czajkowski",
  photo: "/images/nomus-founder.jpg",
  email: "hello@nomus.work",
};
export default function Host({ dark, line }) {
  return (
    <div className="flex items-center gap-3.5" data-testid="room-host">
      <span className="block h-12 w-12 shrink-0 overflow-hidden rounded-full bg-black ring-1 ring-white/10">
        <img
          src={HOST.photo}
          alt={HOST.name}
          width="48"
          height="48"
          loading="lazy"
          className="h-full w-full origin-[58%_38%] scale-[1.45] object-cover grayscale"
        />
      </span>
      <div className="min-w-0 text-[14px] leading-[1.4]">
        <p className="font-medium">{HOST.name}</p>
        <p className={dark ? "text-white/55" : "opacity-55"}>
          {line}{" "}
          <a href={`mailto:${HOST.email}`} className="nm-link break-all">
            {HOST.email}
          </a>
        </p>
      </div>
    </div>
  );
}
